import React from "react";
import { Button, Card } from "react-bootstrap";
import FlatSimpleTable from "../../../../ui/tables/FlatSimpleTable";
import { RefreshCw } from "react-feather";

const RecentPayments = () => {
  const cols = [
    {
      Header: "Fee Name",
      accessor: "fee_name",
    },
    {
      Header: "Description",
      accessor: "description",
    },

    {
      Header: "Total amount",
      accessor: "total_amount",
    },
    {
      Header: "Date",
      accessor: "date",
    },
  ];
  const vals = [
    {
      fee_name: "Tuition Fee",
      description: "Baraka Tuition Fees",
      total_amount: "980000",
      date: "10/ 06/2023 13:42:03",
    },
    {
      fee_name: "Exam Fee",
      description: "Baraka Tuition Fees",
      total_amount: "20000",
      date: "10/ 06/2023 13:42:03",
    },
    {
      fee_name: "Registration Fee",
      description: "Baraka Elias Urio",
      total_amount: "15000",
      date: "10/ 06/2023 13:42:03",
    },
    {
      fee_name: "Tuition Fee",
      description: "Brycen Tuition Fees",
      total_amount: "980000",
      date: "10/ 06/2023 13:42:03",
    },
    {
      fee_name: "Tuition Fee",
      description: "Baraka Tuition Fees",
      total_amount: "980000",
      date: "10/ 06/2023 13:42:03",
    },
  ];
  return (
    <Card>
      <Card.Header>
        <div className="d-flex flex-row justify-content-between">
          <h2 className="h2">Recent Transactions</h2>
          <Button variant="link">
            <RefreshCw size={16} />
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        <FlatSimpleTable values={vals} cols={cols} />
      </Card.Body>
    </Card>
  );
};

export default RecentPayments;
